import React, { useState } from "react";
import "./HomeBanner.css";
import HOMEBAN from "../images/videos/RAD1.mp4";

export default function HomeBanner() {
  const phone = "919597839564";

  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [services, setServices] = useState([]);
  const [message, setMessage] = useState("");

  const serviceOptions = [
    "Solar Plantation",
    "Sewage Treatment Plant (STP)",
    "Effluent Treatment Plant (ETP)",
    "Bio Gas System",
    "Energy Auditing",
    "Green Auditing",
    "Environmental Audit"
  ];

  const handleCheckbox = (value) => {
    setServices((prev) =>
      prev.includes(value)
        ? prev.filter((v) => v !== value)
        : [...prev, value]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!name || !mobile || services.length === 0) {
      alert("Please fill required fields");
      return;
    }

    const whatsappMessage = encodeURIComponent(
      `RAD ENVIRONEX – Service Enquiry\n\n` +
      `Name: ${name}\n` +
      `Mobile: ${mobile}\n\n` +
      `Interested Services:\n` +
      services.map((s, i) => `${i + 1}. ${s}`).join("\n") +
      `\n\nMessage:\n${message}`
    );

    window.open(`https://wa.me/${phone}?text=${whatsappMessage}`, "_blank");
  };

  return (
    <>
      {/* HERO */}
      <section className="hero">
        <video
          className="hero-video"
          src={HOMEBAN}
          autoPlay
          loop
          muted
          playsInline
        />

        <div className="hero-overlay"></div>

        <div className="hero-content">
          <div className="title-box animate-glow">
            <h1>RAD ENVIRONEX</h1>
            {/* <p>Smart Solar Solutions for a Brighter & Sustainable Tomorrow</p> */}
          </div>
        </div>
      </section>

      {/* MODAL FORM */}
      {showForm && (
        <div className="quote-modal">
          <div className="quote-form">
            <h2>Service Enquiry</h2>

            <form onSubmit={handleSubmit}>
              <input
                type="text"
                placeholder="Your Name *"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />

              <input
                type="tel"
                placeholder="Mobile Number *"
                value={mobile}
                onChange={(e) => setMobile(e.target.value)}
              />

              <div className="form-section">
                <p className="section-title">Select Services *</p>

                <div className="checkbox-grid">
                  {serviceOptions.map((item, index) => (
                    <label key={index} className="checkbox-item">
                      <input
                        type="checkbox"
                        onChange={() => handleCheckbox(item)}
                      />
                      <span>{item}</span>
                    </label>
                  ))}
                </div>
              </div>

              <textarea
                placeholder="Additional Message / Requirement"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />

              <div className="form-actions">
                <button type="submit" className="send-btn">
                  Send via WhatsApp
                </button>
                <button
                  type="button"
                  className="cancel-btn"
                  onClick={() => setShowForm(false)}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
